<template>
  <div class="flex grow items-center gap-4">
    <v-switch class="sm-switch grow" hide-details v-model="sensorEnable" :label="$t('Admin.MissionPlanTemplate.Form.SensorEnable')"></v-switch>
    <template v-if="sensorEnable">      
      <v-select hide-details 
        class="grow"
        :items="phases"
        item-text="label"
        item-value="value"
        :label="$t('Admin.MissionPlanTemplate.Form.SensorEnablePhases')"
        v-model="sensorState"
      ></v-select> 
      <v-text-field class="grow" hide-details  type="number" :label="$t('Admin.MissionPlanTemplate.Form.SensorFrequency')"  v-model.number="frequency" />
    </template>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
//@ts-ignore
import Component from 'vue-class-component'

@Component({
  name: 'EditProfilSciRow',  
  props:{         
    value:{
        type:Array,
        default:()=> [1,"111",1]
    }
  }
})
export default class EditProfilSciRow extends Vue {  

  phases = [            
    {label:this.$t('Admin.MissionPlanTemplate.Form.SensorDisabled'),value:0},
    {label:'001 ↑',value:"001"},
    {label:'010 ⥴',value:"010"},
    {label:'011 ⥴↑',value:"011"},
    {label:'100 ↓',value:"100"},
    {label:'101 ↓↑',value:"101"},
    {label:'110 ↓⥴',value:"110"},
    {label:'111 ↓⥴↑',value:"111"}
  ]  

  private value!:Array<number|string> 

  get sensorState(){
    //@ts-ignore
    return (this.value?.at(1) ?? "111")
  }
  set sensorState(newValue){
    //@ts-ignore
    this.inputValue([this.value?.at(0) ?? 1, newValue ?? "111", this.value?.at(2) ?? 1])
  }

  get sensorPhase(){
    //@ts-ignore
    return (this.value?.at(1) ?? "111").toString().padStart(3,'0')
  }

  //@ts-ignore
  get sensorEnable() { return (this.value?.at(0) ?? 0) != 0}  
  set sensorEnable(newValue) {
    //@ts-ignore
    this.inputValue([newValue?1:0,this.value?.at(1) ?? "111",this.value?.at(2) ?? 1])
  }  

  //@ts-ignore
  get frequency() { return this.value?.at(2) ?? 1}  
  set frequency(newValue) {
    //@ts-ignore
    this.inputValue([this.value?.at(0) ?? 1,this.value?.at(1) ?? "111", newValue ?? 1])
  }  

  inputValue(newV:Array<Number>) {
    this.$emit('input',newV)      
  }
  
}
</script>
<style>

</style>